import { EmissionFactorCalculationMethod } from '../../../model/enums/emission-factor-calculation-method';

export function emissionFactorCalculationMethodToApiElectricityEmissionFactorType(
  emissionFactorCalculationMethod: EmissionFactorCalculationMethod
): 'CALCULATED' | 'IMPORTED_GRID' {
  if (emissionFactorCalculationMethod === EmissionFactorCalculationMethod.ImportedGrid) {
    return 'IMPORTED_GRID';
  }
  return 'CALCULATED';
}
